export default "__VITE_ASSET__CmRZfpKL__"